import { render, staticRenderFns } from "./ordList.vue?vue&type=template&id=81ce4eae&scoped=true&"
import script from "./ordList.vue?vue&type=script&lang=js&"
export * from "./ordList.vue?vue&type=script&lang=js&"
import style0 from "./ordList.vue?vue&type=style&index=0&id=81ce4eae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ce4eae",
  null
  
)

export default component.exports